import { useState, useContext } from "react";
import {
	Avatar,
	Button,
	Table,
	TextInput,
	Label,
	Modal,
	List,
	Spinner,
} from "flowbite-react";
import { useParams, Link } from "react-router-dom";
import { HiOutlineArrowRight, HiCurrencyDollar } from "react-icons/hi";
import { useAuth } from "react-oidc-context";
import { YearMap, SportsMapInv } from "./SportMap";
import { UIContext } from "../UIContext";
import { usePlayer } from "../hooks/usePlayer";

export const PlayerTable = ({ playerData }) => {
	const p = playerData.playerData;

	return (
		<div className="flex justify-around">
			<Table>
				<Table.Body>
					<Table.Row>
						{" "}
						<Table.Cell> Name: </Table.Cell>{" "}
						<Table.Cell>
							{" "}
							<p>{p.name}</p>{" "}
						</Table.Cell>{" "}
					</Table.Row>
					<Table.Row>
						{" "}
						<Table.Cell> Sport: </Table.Cell>{" "}
						<Table.Cell>
							{" "}
							<p>
								<Link to={`/Sport/${SportsMapInv[p.sport]}`}>
									{SportsMapInv[p.sport]}
								</Link>
							</p>
						</Table.Cell>{" "}
					</Table.Row>
					<Table.Row>
						{" "}
						<Table.Cell> Position: </Table.Cell>{" "}
						<Table.Cell>
							{" "}
							<p>{p.position}</p>{" "}
						</Table.Cell>{" "}
					</Table.Row>
					<Table.Row>
						{" "}
						<Table.Cell> Jersey: </Table.Cell>{" "}
						<Table.Cell>
							{" "}
							<p>{p.jersey}</p>{" "}
						</Table.Cell>{" "}
					</Table.Row>
					<Table.Row>
						{" "}
						<Table.Cell> Year: </Table.Cell>{" "}
						<Table.Cell>
							{" "}
							<p>{YearMap[p.year]}</p>{" "}
						</Table.Cell>{" "}
					</Table.Row>
					<Table.Row>
						{" "}
						<Table.Cell> Team: </Table.Cell>{" "}
						<Table.Cell>
							{" "}
							<p>
								<Link to={`/Team/${p.team.nilo_id}`}>{p.team.name}</Link>
							</p>{" "}
						</Table.Cell>{" "}
					</Table.Row>
				</Table.Body>
			</Table>
		</div>
	);
};

const ModalComponent = (props) => {
	const [openModal, setOpenModal] = props.modalState;
	const setPaymentMode = props.setPaymentMode;
	return (
		<Modal dismissable show={openModal} onClose={() => setOpenModal(false)}>
			<Modal.Header>Endorsement Terms</Modal.Header>
			<Modal.Body>
				<div className="flex space-y-6">
					<div>
						<p>
							NILO charges a service fee to the Athletes, to cover the costs of
							providing this service. The service includes, but isn't limited to
							-
							<List>
								<List.Item>Athlete Verification</List.Item>
								<List.Item>Validation</List.Item>
								<List.Item>Contract Generation</List.Item>
								<List.Item>Contract Fulfillment & Verification</List.Item>
								<List.Item>Monetary Transactions</List.Item>
							</List>
						</p>
						<p>
							To support this service, NILO charges this Athlete a{" "}
							<b>10% service fee</b>.
						</p>
						<p>
							The Athlete will receive 90% of the amount you pay, with the
							remaining 10% going to pay for the service that NILO provides.
						</p>
					</div>
				</div>
				<hr className="space-y-6" />
				<div className="flex py-4">
					If these terms are acceptable, please click on the "Accept" button
					below.
				</div>
				<div className="flex py-4 space-x-10">
					<Button
						onClick={() => {
							setPaymentMode(true);
							setOpenModal(false);
						}}
					>
						Accept
					</Button>
					<Button
						color="gray"
						onClick={() => {
							setPaymentMode(false);
							setOpenModal(false);
						}}
					>
						Decline
					</Button>
				</div>
			</Modal.Body>
		</Modal>
	);
};

export const GetPlayer = () => {
	const id = useParams().id;
	const auth = useAuth();
	const ctx = useContext(UIContext);
	const [openModal, setOpenModal] = useState(false);
	const [paymentMode, setPaymentMode] = useState(false);

	const { data: playerData, isLoading, isError } = usePlayer(id);

	if (isLoading) {
		return (
			<div className="flex justify-center items-center h-screen">
				<Spinner size="xl" />
			</div>
		);
	}

	if (isError || !playerData) {
		return (
			<div className="flex justify-center items-center h-screen">
				<p className="text-red-500">Could not fetch Player Data</p>
			</div>
		);
	}

	const PaymentComponent = () => {
		if (auth.isAuthenticated === false) {
			return (
				<Button color="gray" onClick={() => auth.signinPopup()}>
					Endorse
					<HiOutlineArrowRight className="ml-2 h-5 w-5" />
				</Button>
			);
		}
		if (paymentMode === false) {
			return (
				<Button
					color="gray"
					/*{...(playerData.verified === false ? { disabled: true } : {})}*/
					onClick={() => setOpenModal(true)}
				>
					Endorse
					<HiOutlineArrowRight className="ml-2 h-5 w-5" />
				</Button>
			);
		}

		const handleSubmit = (e) => {
			e.preventDefault();
			let n = document.getElementById("amount").value;
			let s = {
				recipient: {
					type: "player",
					name: playerData.name,
					id: playerData.nilo_id,
				},
				amount: n * 100,
			};

			ctx.setLoading(true);
			fetch(`/api/stripe/pay`, {
				method: "POST",
				body: JSON.stringify(s),
				headers: {
					"Content-Type": "application/json",
					Authorization: `Bearer ${auth.user.access_token}`,
				},
			})
				.then((resp) => {
					ctx.setLoading(false);
					if (!resp.ok) {
						throw new Error("Cannot submit payment");
					}
					return resp.json();
				})
				.then((r) => {
					window.location.href = r.url;
				})
				.catch((err) => {
					console.error(err);
					ctx.setAlert({
						open: true,
						title: "Payment Error",
						message: `Payment failed: ${err.toString()}`,
						type: "Error",
					});
				});
		};

		return (
			<form onSubmit={handleSubmit}>
				<div>
					<Label htmlFor="amount" value="Amount" />
				</div>
				<TextInput
					id="amount"
					type="text"
					input="numeric"
					placeholder="0.00"
					icon={HiCurrencyDollar}
					required
				/>
				<p />
				<Button type="submit">Submit</Button>
			</form>
		);
	};

	var initials, i;
	i = playerData.name.trim().split(" ");
	if (i.length > 1) {
		initials = i[0].charAt(0) + i[i.length - 1].charAt(0);
	} else {
		initials = i[0].charAt(0);
	}
	let profile_pic = null;
	if ("profile_pic" in playerData.attrs === true) {
		profile_pic = playerData.attrs.profile_pic;
	}
	return (
		<div className="flex flex-col sm:flex-row justify-center">
			<div className="flex flex-col px-24 justify-around">
				{/*<Avatar size="xl" rounded className="my-2" />*/}

				<div className="group w-fit relative justify-around overflow-hidden rounded-full">
					{profile_pic === null ? (
						<Avatar
							size="xl" rounded
							className="my-2"
							placeholderInitials={initials.toUpperCase()}
						/>
					) : (
						<img
							className="sm:h-[192px] sm:w-[192px] sm:object-cover"
							src={profile_pic}
						/>
					)}
				</div>
				<div className="h-px my-2" />
				<PaymentComponent />
				<ModalComponent
					modalState={[openModal, setOpenModal]}
					setPaymentMode={setPaymentMode}
				/>
			</div>
			<div className="h-px my-2" />
			<div className="flex justify-around">
				<PlayerTable playerData={{ playerData }} />
			</div>
		</div>
	);
};
